import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { fetchRecommendations } from '@/ducks/recommendations';
import { useLoginStates } from '@/hooks';

import { Navigation } from '../';
import { contextShape } from '../../../../posting-header.proptypes';
import { getRecosPager } from '../../navigation-selectors';

const mapStateToProps = ({ search }, props) => getRecosPager(search, props);
const mapDispatchToProps = { fetchRecommendations };

export const RecommendationsNavigation = ({ context, className, fetchRecommendations, cursor }) => {
  const { isLoggedOut } = useLoginStates();

  React.useEffect(() => {
    if (!cursor.isInitialised && !isLoggedOut) fetchRecommendations();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <Navigation context={context} className={className} />;
};

RecommendationsNavigation.propTypes = {
  cursor: PropTypes.shape({
    isInitialised: PropTypes.bool.isRequired,
  }).isRequired,
  context: contextShape,
  fetchRecommendations: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RecommendationsNavigation));
